"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("../constant");

var _constant3 = require("./constant");

var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    maintagList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
    subtagList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
    selectText: _propTypes.string,
    heading: _propTypes.string,
    getSelectedData: _propTypes.func,
    randomizeTags: _propTypes.bool,
    deviceType: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    defaultActiveTag: _propTypes.bool,
    marginBottom: _propTypes.string,
    multipleSelectedData: _propTypes.array
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    data: {},
    getSelectedData: function getSelectedData() {},
    randomizeTags: false,
    deviceType: _constant3.DEFAULT_DEVICE_TYPE
  }
};
exports.default = _default;